import './App.css';
import AppRouter from "./AppRouter";
import {UserProvider} from "./context/UserContext";
import {ModalProvider} from "./context/ModalContext";
import Modal from "./components/Modal";
import {AppProvider} from "./context/AppContext";
import {MapSyncProvider} from "./context/MapSyncContext";

function App() {
  return (
    <div className="App">
        <UserProvider>
            <AppProvider>
                <MapSyncProvider>
                    <ModalProvider>
                        <Modal />
                        <AppRouter />
                    </ModalProvider>
                </MapSyncProvider>
            </AppProvider>
        </UserProvider>

    </div>
  );
}

export default App;
